import {
  FETCH_LESSON_COURSE_TREE_REQUEST,
  FETCH_LESSON_COURSE_TREE_SUCCESS,
  FETCH_LESSON_COURSE_TREE_FAILURE,
  CLEAR_LESSON_COURSE_TREE,
} from "../Actions/types";

const initialState = {
  loading: false,
  tree: [],
  error: null,
};

const lessonCourseTreeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LESSON_COURSE_TREE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_LESSON_COURSE_TREE_SUCCESS:
      return { ...state, loading: false, tree: action.payload };
    case FETCH_LESSON_COURSE_TREE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CLEAR_LESSON_COURSE_TREE:
      return { ...initialState }; // Reset to default state
    default:
      return state;
  }
};

export default lessonCourseTreeReducer;
